import { render, staticRenderFns } from "./lgactivitydaily.vue?vue&type=template&id=8a94b296&"
import script from "./lgactivitydaily.vue?vue&type=script&lang=js&"
export * from "./lgactivitydaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports